import React from 'react'
import { useSelector } from "react-redux";
import { Label } from "reactstrap";

import Price from '../../../components/Payment/Price/Price'

import './PaymentSidebar.css'

const PaymentSidebar = ({ children }) => {
   const cartItems = useSelector(state => state.payment.cart)

   return (
      <div className="payment-sidebar">
         <div className="d-flex justify-content-between align-items-baseline mb-2">
            <Label>قبل از تخفیف</Label>
            <Price price={cartItems.reduce((prev, curr) => prev + curr.price * (curr.meterage ?? 1), 0)} />
         </div>
         <div className="d-flex justify-content-between align-items-baseline pb-3 border-bottom">
            <Label>تخفیف</Label>
            <Price price={cartItems.reduce((prev, curr) => prev + (curr.discount ?? 0), 0)} />
         </div>
         <div className="d-flex justify-content-between align-items-baseline mt-3 mb-2">
            <Label>قابل پرداخت</Label>
            <Price price={cartItems.reduce((prev, curr) => prev + (curr.price * (curr.meterage ?? 1)) - (curr.discount ?? 0), 0)}
               size="lg" color="secondary" />
         </div>
         {children}
         <p className="text-right">هزینه‌ی ارسال در ادامه بر اساس آدرس، زمان و نحوه‌ی ارسال انتخابی شما‌ محاسبه و به این مبلغ اضافه خواهد شد</p>
      </div>
   )
}

export default PaymentSidebar
